import { Component, OnInit , Inject, Input } from '@angular/core';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { TypedefdialogComponent } from '../typedefdialog/typedefdialog.component';

import { ServicepoolService } from '../services/servicepool.service';
import { ReponseWebService } from '../datastruct/Meloyi.module';

import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';

export interface DialogData {
	ParamsName : string[]; 
	typechoice: string[];
}


@Component({
  selector: 'app-predefparamchoose',
  templateUrl: './predefparamchoose.component.html',
  styleUrls: ['./predefparamchoose.component.css']
})
export class PredefparamchooseComponent implements OnInit {



  possibleParams = [];
  choosenParams = [] ;

  retourClientWS  : ReponseWebService ;

  rowNumber = 0 ;
  resultArray = [] ;
  subTabLength = 4 ;

  checkStatus = [] ;

  checkboxEditDeactivate = [] ;

  saveBtnState = "done_all" ;

  eltsType = [] ;

  baseElement = "" ;

  constructor(public dialogRef: MatDialogRef<PredefparamchooseComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData, public dialog: MatDialog,  private configServer: ServicepoolService) {
  }

  ngOnInit(): void {
  	this.getAllParamsPredef() ;
  }

  openDialog(nomParam, typeIndex) {
    const dialogRef = this.dialog.open(TypedefdialogComponent, {
      data: {
        ParamsName: nomParam,
        typechoice: ["***"]
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The Type COnfiguration is ::: ');
      this.eltsType[typeIndex] = result ;
    });
  }

  saveVehicParams(){
    var typologie = [] ;
    for (var i = 0; i<this.possibleParams.length ; i++) {
      if(this.checkStatus[i]==true){
        this.choosenParams.push({"nomFrmt": this.possibleParams[i].nomFrmt, "intitule": this.possibleParams[i].nomparam, "type":"custompredef", "values": JSON.parse(this.possibleParams[i].paramvalues) }) ;
      }
    }

    var ret = JSON.stringify({"choosenParams": this.choosenParams, "typos": typologie }) ;
    console.log(ret) ;
    this.dialogRef.close(ret);
  }


  onPrimeChoose(event, i, j) {
  	if (event.target.checked){
  		this.checkStatus[j+4*i]=true ;
  	}
  	else{
    		this.checkStatus[j+4*i]=false ;	  	
  	}
  	console.log(this.baseElement);	
  }

  getAllParamsPredef(){  
    this.configServer.getAllParamsPredef(1).then( (retourbi) => {
        this.retourClientWS = retourbi ;
        var statutrec = this.retourClientWS.statutreq ;
        console.log(this.retourClientWS) ;
        var allPredef = [] ;

        if(statutrec==1){
          console.log("Done There") ;
          var data = this.retourClientWS.data ; 
          for (var i = 0 ; i <data.length; i++) {
            allPredef.push(data[i]) ;
          }
  		  this.possibleParams = allPredef ;
        }
        else
         this.possibleParams = [] ;

	  	var onChunkArray = [] ;
	  	var index = 0 ;
	  	this.resultArray = this.possibleParams.reduce((indexDead, item ) => { 
	  		const chunkIndex = Math.floor(index/this.subTabLength)
	  		if(!onChunkArray[chunkIndex]) {
	  			onChunkArray[chunkIndex] = [] ;
	  		}
	  		onChunkArray[chunkIndex].push(item) ;
	  		index++ ;
	  		return onChunkArray ;
	  	}, []) ;

	  	for (var i = 0; i< this.possibleParams.length; i++) {
	  		this.checkStatus.push(false) ;
	  		this.checkboxEditDeactivate.push(false) ;
	      this.eltsType.push([]) ;
	  	}
    }) ;    
  }


}
